module.exports = __webpack_public_path__ + "img/foto_1.ce3187dd.jpg";